import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ComponentSharedModule } from '@components/component.shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { UiSnackBarModule } from '@uipath/angular/components/ui-snackbar';

import { MaterialModule } from './material.module';

const SHARED_EXPORTS = [
    RouterModule,
    TranslateModule,
    ComponentSharedModule,
    MaterialModule,
    UiSnackBarModule,
];
@NgModule({
    imports: [
        ...SHARED_EXPORTS,
    ],
    exports: [
        ...SHARED_EXPORTS,
    ],
})
export class SharedModule { }
